import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Payment from './components/messages/Payment';

export function PaymentStatus() {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const languageBeforePayment = localStorage.getItem('languageBeforePayment');

		if (languageBeforePayment) {
			const currentLanguage = location.pathname.split('/')[1];

			if (languageBeforePayment !== currentLanguage) {
				const newPath = location.pathname.replace(
					`/${currentLanguage}/`,
					`/${languageBeforePayment}/`
				);
				navigate(newPath + location.search);
			}

			localStorage.removeItem('languageBeforePayment');
		}
	}, [location, navigate]);

	const fullUrl = location.search;
	const statusMatch = fullUrl.match(/[?&]status=([^?&]+)/);

	const exactStatus = statusMatch?.[1];

	return <Payment isSuccess={exactStatus !== 'fail'} />;
}
